<template>
  <div>
    <booking-list-statistic
      :data="statisticOptions"
      :stage-filter.sync="bookingstageFilter"
    />
    <booking-list-filter
    :bookingstage-options="bookingstageOptions"
    :coach-options="coachOptions"
    :customer-options="customerOptions"
    :bookingstage-filter.sync="bookingstageFilter"
    :coach-filter.sync="coachFilter"
    :customer-filter.sync="customerFilter"
    @refetch-data="refetchData"
    />

    <booking-list-add-new
      :is-add-new-booking-sidebar-active.sync="
        isAddNewBookingSidebarActive
      "
      :id="id"
      :data="bookingData"
      :bookingstage-options="bookingstageOptions"
      :coach-options="coachOptions"
      :vehicle-type-options="vehicleTypeOptions"
      :customer-options="customerOptions"
      :driving-center-options="drivingCenterOptions"
      :learning-type-options="learningTypeOptions"
      @refetch-data="refetchData"
      @refetch-statistic="refetchStatistic"
    />
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="addBooking"
              >
                <span class="text-nowrap">Add Booking</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refBookingListTable"
        class="position-relative"
        :items="fetchBookings"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- stacked="md" -->
        <!-- Column : Booking Picture -->
        <template #cell(file)="data">
          <div class="block" v-if="data.item.file">
            <el-image
              style="width: 100px; height: 100px"
              :src="getImagePath(data.item.file)"
              :preview-src-list="getList(getImagePath(data.item.file))"
              fit="fill"
            ></el-image>
          </div>
        </template>
        <template #cell(contact)="data">
          <div>{{ data.item.mobile }}</div>
          <div>{{ data.item.email }}</div>
        </template>
        <template #cell(type)="data">
          <div v-if="data.item.learning_type">
            {{ data.item.learning_type.type_name }}
          </div>
          <div v-if="data.item.vehicle_type">
            {{ data.item.vehicle_type.vehicle_type_name }}
          </div>
          <div v-if="data.item.language">
            {{ data.item.language.language_name }}
          </div>
        </template>
        <!-- Column: Current Status -->
        <template #cell(current_status)="data">
          {{
            data.item.current_status == 1
              ? "Finished"
              : data.item.current_status == 0
              ? "Pending"
              : "Failed"
          }}
        </template>
        <template #cell(product)="data">
          {{ `${data.item.product.name}` }}<br /><span
            v-if="data.item.clinic"
            >{{ data.item.clinic.location_clinic_name }}</span
          >
        </template>

        <!-- Column: PROJECT STAGE -->
        <template #cell(booking_stage)="data">
          <b-badge
            class="text-capitalize"
            v-if="data.item.booking_stage"
            :style="{
              background: data.item.booking_stage.background_color,
              color: data.item.booking_stage.font_color,
            }"
          >
            {{ data.item.booking_stage.stage }}
          </b-badge>
        </template>

        <template #cell(end_time)="data">
          {{ getEndTime(data.item.lesson_time, data.item.minute_per_lesson * data.item.number_of_lesson) }}
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item @click="handleEdit(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="confirmDelete(data.item.id)" v-if="false">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-start
            "
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="
              d-flex
              align-items-center
              justify-content-center justify-content-sm-end
            "
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalBookings"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  BCardGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import axiosIns from "@/libs/axios";
import bookingStoreModule from "../bookingStoreModule";
import useBookingsList from "./useBookingsList";
import { getImgPath } from "@/libs/helper";
import BookingListStatistic from "./BookingListStatistic.vue";
import BookingListAddNew from "./BookingListAddNew.vue";
import BookingListFilter from "./BookingListFilter.vue";
export default {
  data() {
    return {
      getImgPath,
      id: 0,
      bookingData: {},
    };
  },
  components: {
    BFormGroup,
    BCardGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    BImg,
    BookingListStatistic,
    BookingListAddNew,
    BookingListFilter,
  },
  methods: {
    getEndTime(time, minutes){
      let datetime = new Date(time)
      datetime.setMinutes(datetime.getMinutes()+minutes)
      let date =  datetime.toLocaleString('en-US',{hour12:false}).split(" ")
      var time = date[1];
      var mdy = date[0];

      // We then parse  the mdy into parts
      mdy = mdy.split('/');
      var month = parseInt(mdy[0]);
      var day = parseInt(mdy[1]);
      var year = parseInt(mdy[2]);

      // Putting it all together
      var formattedDate = year + '-' + this.getDisplayText(month) + '-' + this.getDisplayText(day) + ' ' + time;
      return formattedDate
    },
    getDisplayText(text){
      let nT = parseInt(text)
      if(nT<10)
      {
        return '0'+nT
      }else{
        return nT
      }
    },
    addBooking(){
      this.id = 0;
      this.bookingData = {
        id: 0,
        customer_id: null,
        coach_id: null,
        driving_center_id: null,
        learning_type_id: null,
        vehicle_type_id: null,
        pick_up_address: '',
        lesson_time: null,
        number_of_lesson: 2,
        minute_per_lesson: 45,
        remark: '',
        booking_stage_id: null,
      }
      this.isAddNewBookingSidebarActive = true
    },
    getList(item) {
      return [item];
    },
    getImagePath(file_path) {
      return process.env.VUE_APP_IMAGE_URL + file_path;
    },
    handleEdit(item) {
      this.id = item.id;
      this.bookingData = { ...item };
      this.isAddNewBookingSidebarActive = true;
    },
   
    confirmDelete(id) {
      this.$swal({
        title: "Are you sure?",
        text: "Your action is final and you will not be able to retrieve the booking.",
        showCancelButton: true,
        confirmButtonText: "Delete",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("booking/deleteBooking", { id: id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const APP_REGISTRATION_STORE_MODULE_NAME = "booking";
    const isAddNewBookingSidebarActive = ref(false);
    const isAddNewCustomerSidebarActive = ref(false);
    

    if (!store.hasModule(APP_REGISTRATION_STORE_MODULE_NAME))
      store.registerModule(
        APP_REGISTRATION_STORE_MODULE_NAME,
        bookingStoreModule
      );

    const statisticOptions = ref([]);

    const refetchStatistic = () => {
      store
        .dispatch(APP_REGISTRATION_STORE_MODULE_NAME + "/fetchStatistic")
        .then((response) => {
          statisticOptions.value = response.data.bookings;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    refetchStatistic();

    const bookingstageOptions = ref([]);
    const coachOptions = ref([]);
    const vehicleTypeOptions = ref([]);
    const customerOptions = ref([]);
    const drivingCenterOptions = ref([])
    const learningTypeOptions = ref([])

    store
      .dispatch(APP_REGISTRATION_STORE_MODULE_NAME + "/fetchOptions", {
        booking_stage: true,
        language: true,
        vehicle_type: true,
        learning_type: true,
        coach: true,
        driving_center: true,
        customer:true,
      })
      .then((response) => {
        bookingstageOptions.value = response.data.booking_stages;
        coachOptions.value = response.data.coaches;
        vehicleTypeOptions.value = response.data.vehicle_types;
        customerOptions.value = response.data.customers;
        learningTypeOptions.value = response.data.learning_types;
        drivingCenterOptions.value = response.data.driving_centers
      })
      .catch((error) => {
        console.log(error);
      });

    const {
      fetchBookings,
      tableColumns,
      perPage,
      currentPage,
      totalBookings,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refetchData,
      refBookingListTable,
      ability,
      bookingstageFilter,
      customerFilter,
      coachFilter,
    } = useBookingsList();

    return {
      isAddNewBookingSidebarActive,
      isAddNewCustomerSidebarActive,
      fetchBookings,
      tableColumns,
      perPage,
      currentPage,
      totalBookings,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refetchData,
      refBookingListTable,
      ability,
      statisticOptions,
      bookingstageFilter,
      bookingstageOptions,
      refetchStatistic,
      coachOptions,
      vehicleTypeOptions,
      customerOptions,
      drivingCenterOptions,
      customerFilter,
      coachFilter,
      learningTypeOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.badge {
  display: block;
  margin: 5px;
  max-width: 200px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.detail-card > .card {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24) !important;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}

.detail-card > .card:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22) !important;
}

.product-heading {
  min-width: 300px;
}
</style>
